
<div class="delinquency-notice">
  <div class="background" />
  <div class="main">
    <p class="hold" @click="close">⚠️Your account is on hold⚠️</p>
    <p>There was a payment problem on your recent order:</p>
    <p class="has-text-weight-bold" style="padding: 12px 0">
      {{ delinquencyNotice }}
    </p>
    <p>
      Please contact us to remedy this issue or if you have any questions.
    </p>
    <p class="buttons" style="margin: 16px 0">
      <span class="button is-capitalized is-medium pulse" @click="contactChatSupport"><i
          class="far fa-comment" />&nbsp;Live Chat</span>
      <span class="button is-capitalized is-medium pulse" @click="emailAboutPayment"><i
          class="far fa-envelope" />&nbsp;Email</span>
      <span class="button is-medium" @click="restart">Restart</span>
    </p>
  </div>
</div>
